@if (inputFieldConfig && isPaymentRailSelectorVisible) {
<div [formGroup]="beneficiaryForm">
  <div class="pointer-events-none">
    <finxone-select-dropdown
      [options]="inputFieldConfig?.options ?? []"
      [formControlName]="inputFieldConfig.name"
      [optionValueKey]="'value'"
      [optionLabelKey]="'label'"
      [appendToBody]="true"
      [validationConfig]="validationConfig"
      [formControlInvalid]="
        !!(
          beneficiaryForm.get(inputFieldConfig.name)?.invalid &&
          beneficiaryForm.get(inputFieldConfig.name)?.touched
        )
      "
      [selectedOption]="selectedOptionLabel"
      [label]="inputLabel"
      [placeholder]="''"
    ></finxone-select-dropdown>
  </div>
</div>
}
